<template>

    <m-edit1/>

    <m-dashboard-layout-1 v-bind='{...{"menuPosition":"store_footer","sideBar":"col-lg-2","contentWrapper":"col-lg-10"},...{}}' :style='""' class="" >
                <template #default>   <m-h5 v-bind='{...{},...{}}' :style='""' class="text-dark py-2" >
                <template #default>فایل ها   </template>
                </m-h5><m-dashboard-products-300 v-bind='{...{},...{}}' :style='""' class="dashboard-products-300" ></m-dashboard-products-300></template>
                </m-dashboard-layout-1>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDashboardLayout1 from '@moeinmdn/miw-alpha-components/src/package/DashboardLayout/DashboardLayout1'; import mH5 from '@moeinmdn/miw-alpha-components/src/package/Tags/H5'; import mDashboardProducts300 from '@moeinmdn/miw-alpha-components/src/package/Product/Products/Dashboard/DashboardProducts300/DashboardProducts300';

export default {
    name: 'HomeView',
    components: {mEdit1, mDashboardLayout1,mH5,mDashboardProducts300 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
